import { pipe } from 'lodash/fp'
import { withTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import { Dispatch } from 'redux'
import { destroy, getFormValues, submit } from 'redux-form'
import { IStore } from '../../../reducers'
import {
  getModalCloseReservationIsOpen,
  getModalServicesIsLoading,
  getModalServicesIsOpen,
  getUpdateModalReservationId,
} from '../../../reducers/bookingCalendar/selectors/getModalOpen'
import { toggleServicesModal } from '../../../actions/bookingCalendar/reservationModal/toggleServicesModal'
import { getModalProvenancesIsOpen } from '../../../reducers/provenances/selectors/getModalOpen'
import { toggleProvenancesModal } from '../../../actions/provenances/toggleProvenancesModal'
import { addProvenance } from '../../../actions/provenances/addProvenance'
import { toggleCloseModal } from '../../../actions/bookingCalendar/reservationModal/toggleCloseModal'
import {
  toggleCreateReservationModal,
  toggleUpdateReservationModal,
} from '../../../actions/bookingCalendar/reservationModal/toggleReservationModal'
import { FormNames } from '../../Form/CreateReservation'
import { deleteProvenance } from '../../../actions/provenances/deleteProvenance'
import {
  getProvenancesWithInitial,
  getProvenanceWithoutDeleted,
} from '../../../reducers/provenances/selectors/getProvenances'
import { getServices } from '../../../reducers/bookingCalendar/selectors/getServices'
import { TransferReservationModal } from '../TransferReservationModal'
import CopyReservationModal from '../CopyReservationModal/CopyReservationModal'
import connectCreateModal from './connectCreateModal'
import ReservationModal from './ReservationModal'
import {
  default as ServicesModalRaw,
  IServicesModalDispatch,
  IServicesModalProps,
  ServicesForm,
} from './ServicesModal'
import {
  default as ProvenancesModalRaw,
  IProvenancesModalDispatch,
  IProvenancesModalProps,
} from './ProvenancesModal'
import {
  default as CloseModalRaw,
  ICloseModalDispatch,
  ICloseModalProps,
} from './CloseModal'
import connectUpdateModal from './connectUpdateModal'

export const CreateReservationModal = pipe(
  connectCreateModal,
  withTranslation(),
)(ReservationModal) as any

export const UpdateReservationModal = pipe(
  connectUpdateModal,
  withTranslation(),
)(ReservationModal)

const mapStateToPropsServices = (state: IStore): IServicesModalProps => ({
  isLoading: getModalServicesIsLoading(state),
  open: getModalServicesIsOpen(state),
  services: getServices(state),
})

const mapDispatchToPropsServices = (
  dispatch: Dispatch,
): IServicesModalDispatch => ({
  close: () => dispatch(toggleServicesModal()),
  submitChanges: () => dispatch(submit('services')),
})

const mapStateToPropsProvenances = (state: IStore): IProvenancesModalProps => ({
  open: getModalProvenancesIsOpen(state),
  provenances: getProvenanceWithoutDeleted(state),
  provenancesWithInitial: getProvenancesWithInitial(state),
})

const mapDispatchToPropsProvenances = (
  dispatch: Dispatch,
): IProvenancesModalDispatch => ({
  addProvenance: (provenance: string) => dispatch(addProvenance(provenance)),
  close: () => dispatch(toggleProvenancesModal()),
  deleteProvenance: (id: number) => () => dispatch(deleteProvenance(id)),
})

const mapStateToPropsClose = (state: IStore): ICloseModalProps => ({
  open: getModalCloseReservationIsOpen(state),
})

const mapDispatchToPropsClose = (dispatch: Dispatch): ICloseModalDispatch => ({
  close: () => dispatch(toggleCloseModal()),
  closeReservationModal: (form: FormNames) => {
    form === FormNames.Create
      ? dispatch(toggleCreateReservationModal(false))
      : dispatch(toggleUpdateReservationModal(null, false))
    dispatch(destroy(form))
  },
})

export const CloseModal = connect<
  ICloseModalProps,
  ICloseModalDispatch,
  ICloseModalProps
>(
  mapStateToPropsClose,
  mapDispatchToPropsClose,
)(CloseModalRaw)

export const ServicesModalCreate = connect(
  mapStateToPropsServices,
  mapDispatchToPropsServices,
)(ServicesModalRaw)

export const ServicesModalUpdate = connect(
  mapStateToPropsServices,
  mapDispatchToPropsServices,
)(ServicesForm)

export const ProvenancesModal = connect(
  mapStateToPropsProvenances,
  mapDispatchToPropsProvenances,
)(ProvenancesModalRaw)

const mapStateToCopyTransferModalProps = (state: IStore) => {
  const eventId = getUpdateModalReservationId(state)
  const formName = eventId ? 'update_reservation' : 'create_reservation'
  const formDataSelector = getFormValues(formName)
  return {
    eventData: formDataSelector(state),
    eventId,
  }
}

export const ReservationConnectedCopyModal = connect(
  mapStateToCopyTransferModalProps,
)(CopyReservationModal)
export const ReservationConnectedTransferModal = connect(
  mapStateToCopyTransferModalProps,
)(TransferReservationModal)

export const CopyModal = CopyReservationModal
